import React, {Component} from "react";
import {connect} from "react-redux";
import {requestRecordPayment} from "../../actions/AccountApiActions";
import LogPanel from "../../subscriptions/panels/LogPanel";

class SubscriptionLogView extends Component {

  render() {
    return (
      <div className="SubscriptionLogView">
        <LogPanel
          subscriptionId={this.props.subscriptionId}
          />
      </div>
    )
  }

}

export default connect(null, {requestRecordPayment})(SubscriptionLogView);